module.exports = __webpack_public_path__ + "../front/img/768_3skuffer+hylde.41444711.svg";